import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { ToastProvider } from './context/ToastContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Gallery from './pages/Gallery';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Cart from './pages/Cart';
import Login from './pages/Login';
import Checkout from './pages/Checkout';
import Profile from './pages/Profile';
import OrderSuccess from './pages/OrderSuccess';
import Admin from './pages/Admin';
import Impresszum from './pages/Impresszum';
import Adatkezeles from './pages/Adatkezeles';
import '@/App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <ToastProvider>
            <div className="App min-h-screen bg-[#0b0c10] text-white">
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/termekek" element={<Products />} />
                <Route path="/termekek/:id" element={<ProductDetail />} />
                <Route path="/szolgaltatasok" element={<Services />} />
                <Route path="/szolgaltatasok/:id" element={<ServiceDetail />} />
                <Route path="/galeria" element={<Gallery />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:id" element={<BlogPost />} />
                <Route path="/kosar" element={<Cart />} />
                <Route path="/bejelentkezes" element={<Login />} />
                <Route path="/penztar" element={<Checkout />} />
                <Route path="/profil" element={<Profile />} />
                <Route path="/rendeles/:id" element={<OrderSuccess />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/impresszum" element={<Impresszum />} />
                <Route path="/adatkezeles" element={<Adatkezeles />} />
              </Routes>
              <Footer />
            </div>
          </ToastProvider>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;